import { NavLink, Outlet, useOutletContext } from "react-router-dom";
import { BarChart3, CalendarDays, Gauge, Package, Receipt, Wallet } from "lucide-react";
import { cn } from "@/lib/utils";

export const REPORT_TABS = [
  { to: "/reports", label: "Business reports", icon: BarChart3, testId: "reports-nav-business" },
  { to: "/kpi", label: "Geronimo KPIs", icon: Gauge, testId: "reports-nav-kpi" },
  { to: "/appointments", label: "Appointments", icon: CalendarDays, testId: "reports-nav-appointments" },
  { to: "/orders", label: "Product orders", icon: Receipt, testId: "reports-nav-orders" },
  { to: "/products", label: "Products", icon: Package, testId: "reports-nav-products" },
  { to: "/payslips", label: "Payroll bonus", icon: Wallet, testId: "reports-nav-payslips" },
];
export const REPORT_PATHS = REPORT_TABS.map((t) => t.to);

export function ReportsNav() {
  return (
    <nav aria-label="Reports" className="mb-8 -mt-2 border-b border-zinc-200" data-testid="reports-nav">
      <ul className="thin-scroll -mb-px flex gap-1 overflow-x-auto">
        {REPORT_TABS.map((t) => (
          <li key={t.to}>
            <NavLink
              to={t.to}
              end={t.to === "/reports"}
              data-testid={t.testId}
              className={({ isActive }) => cn(
                "inline-flex items-center gap-2 whitespace-nowrap border-b-2 px-3 py-2.5 text-sm transition-colors",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-le-focus focus-visible:ring-offset-1 rounded-t-md",
                isActive
                  ? "border-le-primary font-semibold text-le-primary-deep"
                  : "border-transparent text-zinc-600 hover:border-zinc-300 hover:text-zinc-950"
              )}
            >
              {({ isActive }) => (
                <>
                  <t.icon className={cn("h-4 w-4", isActive ? "text-le-primary-text" : "text-zinc-500")} aria-hidden />
                  {t.label}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

// Shared shell for every report page: tab bar on top, page below (keeps the Layout outlet context).
export default function ReportsShell() {
  const ctx = useOutletContext();
  return (
    <>
      <ReportsNav />
      <Outlet context={ctx} />
    </>
  );
}
